import { PillTheme } from "@redotech/redo-model/pill-theme";
import { memo, useState } from "react";
import { RedoModal } from "../arbiter-components/modal/redo-modal";
import { TagInputFields } from "./tag-fields";

// Tag like object, less restrictive on "source" so we can reuse this component
export type TagWithId = {
  name: string;
  pillTheme: PillTheme;
  tagId: string;
  source: string;
};

export const CreateTagModal = memo(function CreateTagModal({
  cancelClicked,
  handleCreateTag,
}: {
  cancelClicked(): void;
  handleCreateTag: ({
    name,
    pillTheme,
  }: {
    name: string;
    pillTheme: PillTheme;
  }) => Promise<void>;
}) {
  const [pillTheme, setPillTheme] = useState<PillTheme>(PillTheme.NORMAL);
  const [name, setName] = useState("");

  async function handleSubmit() {
    await handleCreateTag({ name, pillTheme });
  }

  return (
    <RedoModal
      isOpen
      modalSize="sm"
      onModalCloseRequested={cancelClicked}
      primaryButton={{ text: "Create", onClick: handleSubmit, disabled: !name }}
      secondaryButton={{ text: "Cancel", onClick: cancelClicked }}
      title="Create tag"
    >
      <TagInputFields
        name={name}
        pillTheme={pillTheme}
        setName={setName}
        setPillTheme={setPillTheme}
        showNameError={false}
      />
    </RedoModal>
  );
});
